// extracted by mini-css-extract-plugin
module.exports = {"logo":"CardLogo_logo__qEDqn","badge":"CardLogo_badge__kv9PM"};